/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeServicesCreateService } from "../../funcs/computeServicesCreateService.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateServiceRequest$inboundSchema,
};

export const tool$computeServicesCreateService: ToolDefinition<typeof args> = {
  name: "compute-services-create-service",
  description: `Create a service`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeServicesCreateService(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
